module.exports = __webpack_public_path__ + "media/assets/site_images/android_store-9c5abc13c05f405d292a82ea70556729.png";